import type { ReactNode } from "react";

import { useSessionManager } from "../hooks/use-session-manager";

type SessionProviderProps = {
  children: ReactNode;
};

export const SessionProvider = ({ children }: SessionProviderProps) => {
  // Initialize session manager for logged-in users
  useSessionManager();

  return <>{children}</>;
};
